import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { DialogComponent } from '../components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogHelperService {

  constructor(private dialog: MatDialog, private translate: TranslateService) { }
  dialogRef!: MatDialogRef<DialogComponent>;

  public open(options: any) {
    return this.dialogRef = this.dialog.open(DialogComponent, {
      data: {
        title: options.title,
        message: options.message,
        cancelText: options.cancelText,
        confirmText: options.confirmText,
        component: options.component,
        id: options.id
      }
    });
  }

  public confirmed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(take(1), map(x => {
      return x
    }));
  }

  closed() {
    return this.dialogRef.afterClosed().pipe(take(1), map(x => {
      return x
    }));
  }

  async defaultDialog(title: string, confirmText: string, message: string, confirmAction: () => Promise<any>) {

    const options = {
      title: title,
      confirmText: confirmText,
      message: message
    };

    this.open(options);

    return this.closed().subscribe(result => {
      if (result) {
        confirmAction();
      }
      return of(result);
    });
  }

}
